import { Injectable } from '@angular/core';
import { DictionaryService } from './dictionary.service';
import { UserService } from './user.service';
import { MacrosService } from './macros.service';

@Injectable()
export class DemandService {
  public demandTypeSettings: Array<any>;
  public demandTypes: Array<any>;
  public sideMenuSections: Array<any>;
  public userTypes: Array<any>;
  public targetingOptions: Array<any>;
  public eventsList: Array<any>;
  public cappingTypeSettings: Array<any>;
  public cappingLimits: any;
  public demandModel: any;
  public extraParamsDefaultValue: any;
  public listsLimit: number;
  public ipListsLimit: number;
  public bidders: Array<any>;
  public biddersAllowed: Array<any>;
  public bidderConfs: any;

  private macroNames: string[];
  constructor(
    public dictionaryService: DictionaryService,
    public userService: UserService,
    public macrosService: MacrosService
  ) {
    this.demandTypeSettings = [
      { id: 0, sections: [true, true, true, true, true, true, true, true], active: true }, //VAST
      { id: 1, sections: [true, true, true, true, true, false, false, true], active: true }, //CedatoX
      { id: 2, sections: [true, true, true, true, true, true, true, true], active: false, featureFlag: 'spotx_demand' }, //SpotX Direct
      { id: 3, sections: [true, true, true, true, true, true, true, true], active: true, featureFlag: 'rtb_demand' }, //RTB
      { id: 4, sections: [true, true, true, true, true, true, true, true], active: true, featureFlag: 'prebid_vast' }, //Prebid
    ];
    this.sideMenuSections = [
      { name: 'SETTINGS', value: 'demandSettings', toggleStatus: true },
      {
        name: 'ASSIGNED_CAMPAIGNS',
        value: 'demandAssignedCampaigns',
        toggleStatus: true,
        featureFlag: 'manage_campaigns',
        editModeOnly: true,
      },
      { name: 'ASSIGNED_SUPPLY', value: 'demandAssignedSupplies', toggleStatus: true },
      { name: 'TARGETING', value: 'demandTargeting', toggleStatus: true },
      { name: 'RESTRICTIONS', value: 'demandRestrictions', toggleStatus: true },
      { name: 'CALLBACKS', value: 'demandCallbacks', toggleStatus: true },
      {
        name: 'EXTRA_PARAMS',
        value: 'extraParams',
        toggleStatus: true,
        isAdminOnly: true,
        onIf: false,
        iconNameIfOn: 'file',
        iconTooltip: 'Extra Params were added',
      },
      { name: 'EXPERIMENTAL_FEATURES', value: 'experimentalFeatures', toggleStatus: true, isAdminOnly: true },
    ];
    this.demandTypes = [];
    this.userTypes = [
      { name: 'AUTO', val: 0 },
      { name: 'USE_FLASH_BY_DEFAULT', val: 1 },
      { name: 'USE_JS_BY_DEFAULT', val: 2 },
      { name: 'USE_FLASH_ONLY', val: 3 },
      { name: 'USE_JS_ONLY', val: 4 },
    ];
    this.targetingOptions = [
      { id: 0, name: 'ALL' },
      { id: 1, name: 'INCLUDE' },
      { id: 2, name: 'EXCLUDE' },
    ];
    this.cappingTypeSettings = [
      { id: 1, name: this.dictionaryService.get('DAILY_IMPRESSIONS') },
      { id: 2, name: this.dictionaryService.get('DAILY_AD_REQUESTS') },
    ];
    this.eventsList = [
      { name: this.dictionaryService.get('AD_START'), eventId: 2, typeId: 0 },
      { name: this.dictionaryService.get('AD_COMPLETE'), eventId: 3, typeId: 0 },
      { name: this.dictionaryService.get('AD_CLICK'), eventId: 4, typeId: 0 },
      { name: this.dictionaryService.get('IVT_DETECTION'), eventId: 2, typeId: 1 },
    ];
    this.bidders = [];
    this.biddersAllowed = [];
    this.bidderConfs = {};
    this.demandModel = {
      // Settings
      vast_name: '',
      type: 0,
      is_desktop: false,
      is_mobile_app: false,
      is_mobile_web: false,
      partnerId: null,
      partnerName: null,
      vast_url: '',
      user_type: 0,
      costValue: 0,
      prebidFraud: false,
      is_active: true,
      limitAssign: false,
      is_intent_demand: false,
      is_google_demand: false,
      premium: false,
      rtb_vendor: null,
      deal_id: -1,
      floorCPM: 0,
      assigned_via_cedatox: 0,
      bidder: {
        bidderId: -1,
        json: '',
      },
      // Assigned Supply
      vast_players: [],
      // Targeting
      targeting: {
        dma: { type: 0, list: [] },
        app_bundle_oper: 1,
        detected_domain_oper: 1,
        location: { type: 0, list: [] },
        browsers: { type: 0, list: [] },
        os: { type: 0, list: [] },
        targetingSizes: { type: 0, list: [] },
        viewability: 40,
        viewability_enabled: 0,
        viewability_ispass: 0,
        envs: { type: 0, list: [] },
        targeting_id: 0,
        ivt: 10,
        ivt_enabled: 0,
        ivt_ispass: 0,
        vast_domains: { type: 0, list: [] },
        time_targeting: { list: [] },
        state: { type: 0, list: [] },
        iasAvoidance: { list: [], enabled: false },
        iasTargeting: { list: [], enabled: false },
        highRiskAvoidance: { list: [], enabled: false },
        schains: null,
      },
      // Restrictions
      user_mvr: 3,
      custom_user_mvr: 1,
      custom_mvr: false,
      vast_capping: [
        {},
        {
          active: false,
          cappingType: 1,
          cappingValue: null,
          paceOption: 1,
        },
        {
          active: false,
          cappingType: 2,
          cappingValue: null,
          paceOption: 1,
        },
        {
          active: false,
          cappingType: 3,
          cappingValue: null,
          intervalTypeID: 1,
          capTypeID: 1,
        },
        {
          active: false,
          cappingType: 4,
          cappingValue: null,
          intervalTypeID: 1,
          capTypeID: 1,
        },
      ],
      domainListType: 0,
      domainLists: [],
      urlListType: 0,
      urlLists: [],
      ipListType: 0,
      ipLists: [],
      shouldRotate: true,
      // Callbacks
      callbacks: [],
    };
    this.extraParamsDefaultValue = {
      json: '{}',
      extra_params_length: 0,
    };
    this.cappingLimits = {};
    this.listsLimit = 30;
    this.ipListsLimit = 5;
    this.macroNames = this.macrosService.getMacrosName('demand');
  }

  getMacroList(): string[] {
    return this.macroNames;
  }

  getCustomPlayerSizeId(width: number, height: number, operator: string) {
    let num: number = width * height;
    switch (operator) {
      case '=':
        return `a:${num}-${num}`;
      case '>':
        num += 1;
        return `a:${num}-all`;
      case '<':
        num -= 1;
        return `a:0-${num}`;
      case '≥':
        return `a:${num}-all`;
      case '≤':
        return `a:0-${num}`;
      default:
        return '';
    }
  }

  isFixedCPM(costType: number) {
    costType = Number(costType);
    return costType === 2 || costType === 3 || costType === 5;
  }

  isRevshareCPM(costType: number) {
    costType = Number(costType);
    return costType === 1 || costType === 4;
  }

  isNoneCPM(costType: number) {
    costType = Number(costType);
    return costType === 7;
  }

  isDemandTypeChangeable() {
    return this.userService.networkData
      ? this.userService.networkData.cedatox_marketplace === '1' ||
          this.userService.getFeatureState('rtb_demand') ||
          this.userService.getFeatureState('prebid_vast')
      : false;
  }

  getDemandTypes(showAll: boolean = false) {
    const demandTypes: Array<any> = [];
    let passFeatureFlag: boolean;
    let passPublisher: boolean;
    for (let i = 0; i < this.demandTypes.length; i++) {
      passFeatureFlag = this.demandTypes[i].featureFlag
        ? this.userService.getFeatureState(this.demandTypes[i].featureFlag)
        : true;
      passPublisher =
        this.userService.isPublisher() || this.userService.isPublisherNetwork()
          ? this.demandTypes[i].hideFromPublishersNetwork !== true
          : true;
      if (this.demandTypes[i].active && ((passFeatureFlag && passPublisher) || showAll)) {
        demandTypes.push(this.demandTypes[i]);
      }
    }
    return demandTypes;
  }

  static getRTBDemandDealID(dealId: string) {
    return dealId && dealId !== '-1' ? dealId : '';
  }

  static setRTBDemandDealID(dealId: string) {
    return dealId === '' ? -1 : dealId;
  }

  chooseAdapter(bidderConf, bidderJson): number {
    const resp = 0;
    let jsonKeys: string[];
    let oneAdapterKeys: string[];
    let find: boolean;
    if (bidderConf && bidderJson && bidderConf.adapters) {
      jsonKeys = Object.keys(JSON.parse(bidderJson));
      jsonKeys.sort();

      for (let i = 0; i < bidderConf.adapters.length; i++) {
        find = true;
        oneAdapterKeys = Object.keys(bidderConf.adapters[i].macrosKeys);
        for (let j = 0; j < oneAdapterKeys.length; j++) {
          if (!jsonKeys.includes(oneAdapterKeys[j])) {
            find = false;
          }
        }
        if (find) {
          return i;
        }
      }
    }

    return resp;
  }

  deepValue(obj: any, path: string): any {
    const pathArr: string[] = path.split('.');
    for (let i = 0; i < pathArr.length; i++) {
      obj = obj[pathArr[i]];
    }
    return obj;
  }

  buildExtraParamsDefs() {
    return {
      extra_params_enabled: false,
      extra_params: this.extraParamsDefaultValue.json,
    };
  }
}
